import React, { useEffect, useState } from 'react';
import AuthService from '../Services/AuthService';
import VolumesService from '../Services/VolumesService';
import { useToasts } from 'react-toast-notifications';
import { Alert, Card, CardBody, CardHeader, CardFooter, FormGroup, Nav, NavItem, NavLink, TabContent, 
    TabPane, Input, Label, Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, Row, Col } from 'reactstrap';
import { Table, Tr, Td, Thead, Tbody, Th } from 'react-super-responsive-table';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowDown,
    faArrowDownWideShort,
    faArrowUp,
    faArrowUpWideShort, faCamera, faCheck, faMoneyCheckAlt, faPenToSquare, faSync, faTimes, faWeightScale
} from "@fortawesome/free-solid-svg-icons";
import LocalService from '../Services/LocalService';
import FileService from '../Services/FileService';
import { setTranslations, setDefaultLanguage, withTranslation } from 'react-multi-lang'

const Volumes = ({ t }) => {
    const [volumes, setVolumes] = useState([]);
    const [activeTab, setActiveΤab] = useState('1');
    const [newSearch, setNewSearch] = useState('');
    const [user, setUser] = useState(false);
    const [config, setConfig] = useState(false);
    const [newVolume, setNewVolume] = useState({});
    const [addVolumeModal, setAddVolumeModal] = useState(false);
    const [stateManager, setStateManager] = useState(1);
    const [measurement, setMeasurement] = useState({});
    const [measureVolumeOpen, setMeasureVolumeOpen] = useState(false);
    const [assessmentsModalOpen, setAssessmentsModalOpen] = useState(false);
    const [assessments, setAssessments] = useState([]);
    const [assessment, setAssessment] = useState({});
    const [addingAssessment, setAddingAssessment] = useState(false);
    const [syncingToErp, setSyncingToErp] = useState(false);
    const [weighingModalOpen, setWeighingModalOpen] = useState(false);
    const [weight, setWeight] = useState(0);
    const [weighing, setWeighing] = useState({});
    const [weighingInterval, setWeighingInterval] = useState(null);
    const [completingVolumeModalOpen, setCompletingVolumeModalOpen] = useState(false);
    const [volumeToComplete, setVolumeToComplete] = useState({});
    const [uploadingForVolume, setUploadingForVolume] = useState({});
    const [managingPhotosModalOpen, setManagingPhotosModalOpen] = useState(false);
    const [activeImage, setActiveImage] = useState('');
    const [seeingImage, setSeeingImage] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [activeVolume, setActiveVolume] = useState({});
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('created');
    const [total, setTotal] = useState(0);

    const { addToast } = useToasts();

    const authService = new AuthService();
    const volumesService = new VolumesService();
    const localService = new LocalService();
    const fileService = new FileService();

    const totalPages = Math.max(1, Math.ceil(total / perPage));
    const currentPage = Math.min(Math.max(1, page), totalPages);
    const startIndex = total === 0 ? 0 : (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    useEffect(() => {
        try{
            setUser(authService.getUser());
            setConfig(authService.getConfig());
        }catch(e) {
            addToast(e, { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        }
    }, []);

    useEffect(() => {
        const maxPage = Math.max(1, Math.ceil(total / perPage));
        if (total > 0 && page > maxPage) {
            setPage(maxPage);
        }
    }, [total, perPage, page]);

    useEffect(() => {
        getVolumes(page, perPage, status, search);
    }, [page, perPage, status]);

    const getVolumes = (targetPage = page, targetPerPage = perPage, targetStatus = status, targetSearch = search) => {
        setVolumes([]);
        volumesService.getVolumes(targetSearch, targetStatus, targetPage, targetPerPage).then(vs => {
            if (vs) {
                setVolumes(vs[0] || []);
                setTotal(vs[1] || 0);
            }
            setStateManager(stateManager + 1);
        }).catch(e => {
            addToast("Αδυναμία λήψης όγκων", { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        });
    };

    const handleSearch = () => {
        if (page === 1) {
            getVolumes(1, perPage, status, search);
        } else {
            setPage(1);
        }
    };

    const toggleAddVolumeModal = () => {
        setAddVolumeModal(!addVolumeModal);
    };

    const toggleMeasureVolumeOpen = () => {
        setMeasureVolumeOpen(!measureVolumeOpen);
    }

    const toggleAssessmentsModalOpen = () => {
        setAssessmentsModalOpen(!assessmentsModalOpen);
    };

    const toggleManagePhotosModalOpen = () => {
        setManagingPhotosModalOpen(!managingPhotosModalOpen);
    }

    const toggleSeeingImage = () => {
        setSeeingImage(!seeingImage);
    }

    const getShelves = () => {
        let conf = authService.getConfig();
        if(conf){
            return conf.shelves
        }
        else{
            return [];
        }
    };

    const selectTab = (tab) => {
        setActiveΤab(tab);
        setPage(1);
        if(tab === '1'){
            setStatus('created');
        }
        if(tab === '2'){
            setStatus('assessed');
        }
        if(tab === '3' || tab === '6'){
            setStatus('completed');
        }
        if(tab === '4' || tab === '7'){
            setStatus('drafts');
        }
        if(tab === '5'){
            setStatus('toCompleteAssessment');
        }
    };

    const submitAddVolume = (e) => {
        e.preventDefault();
        setBtnDisabled(true);
        if(!newVolume.self){
            addToast('Πρέπει να επιλέξετε πατάρι εξόρυξης για να δημιουργήσετε τον όγκο.', { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 5000 });
            setBtnDisabled(false);
            return;
        }
        volumesService.createVolume(newVolume).then(v => {
            let vname = v.date.split('T')[0].split('-').reverse().join('-') + '-' + v.dayNumber;
            addToast(`Ο όγκος ${vname} δημιουργήθηκε με επιτυχία, πραγματοποιείται επαναφόρτωση των όγκων`, { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
            toggleAddVolumeModal();
            getVolumes();
            setBtnDisabled(false);
        }).catch(e => {
            addToast(e, { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
            setBtnDisabled(false);
        })
    };

    const measureVolume = (volumeId) => {
        setMeasurement({
            ...measurement,
            volumeId
        });
        toggleMeasureVolumeOpen();
    };

    const submitMeasureVolume = (e) => {
        e.preventDefault();
        setBtnDisabled(true);
        try{
            volumesService.addMeasurement(measurement).then(m => {
                addToast(t("volumes.sizingSavedSuccessfully"), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
                getVolumes();
                toggleMeasureVolumeOpen();
                setBtnDisabled(false);
            }).catch(e => {
                if(e.error){
                    addToast(e.error, { appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000 });
                }
                else{
                    addToast(t(`volumes.sizingError`), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000 });
                }
                setBtnDisabled(false);
            });
        }catch(e){
            addToast(e, { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 3000 });
            setBtnDisabled(false);
        }
    };

    const assessVolume = (v) => {
        if(v.wh !== authService.getConfig().whCode){
            addToast(t("volumes.otherQuarryVolume"), {
                appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000
            });
        }
        else{
            setAssessments(v.assessments ? v.assessments : []);
            setActiveVolume(v);
            setAssessment({volumeId: v.volumeId});
            toggleAssessmentsModalOpen();
        }
    };

    const createAssessment = (e) => {
        e.preventDefault();
        setBtnDisabled(true);
        try{
            volumesService.assess(assessment).then(a => {
                let v = volumes.filter(vol => vol.volumeId === assessment.volumeId)[0];
                v.assessments.push(a);
                if(v.assessments === 3 && v.wh === '4'){
                    v.finalAssessment = volumesService.decideAssessment(v);
                    volumesService.sendFinalAssessment(v);
                }
                if(volumesService.draftAssessments.includes(assessment.assessment) && !v.measurementId){
                    volumesService.addMeasurement({
                        volumeId: v.volumeId,
                        length: 0.1,
                        width: 0.1,
                        depth: 0.1
                    }).then(r => getVolumes());
                }
                getVolumes();
                setAssessment({});
                setAddingAssessment(false);
                toggleAssessmentsModalOpen();
                addToast(t("volumes.assessmentSuccess"), 
                    { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
                setBtnDisabled(false);
            }).catch(e => {
                if(e.error){
                    addToast(e.error, 
                        { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
                }
                else{
                    addToast(t("volumes.assessmentError"), 
                        { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
                }
                setBtnDisabled(false);
            });
        }catch(e){
            addToast(e, 
                    { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
            setBtnDisabled(false);
        }
    }

    const decideAssessment = (v) => {
        if(authService.getConfig())
            return volumesService.decideAssessment(v);
    };

    const syncToErp = (v) => {
        setSyncingToErp(true);
        try{
            volumesService.syncToErp(v).then(r => {
                addToast(t('volumes.syncSuccess'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000 });
                getVolumes();
                setSyncingToErp(false);
            }).catch(e => {
                setSyncingToErp(false);
                addToast(t('volumes.syncError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000 });
            });
        }catch(e){
            setSyncingToErp(false);
            addToast(e, { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
        }
    };

    const syncToErpPrilepNordia = (v) => {
        setSyncingToErp(true);
        v = {
            ...v,
            wh: '319',
            itemCode: volumesService.getVolumeItem(v)
        };
        
        try{
            volumesService.syncToErp(v).then(r => {
                addToast(t('volumes.syncSuccess'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000 });
                getVolumes();
                setSyncingToErp(false);
            }).catch(e => {
                setSyncingToErp(false);
                addToast(t('volumes.syncError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000 });
            });
        }catch(e){
            setSyncingToErp(false);
            addToast(e, { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
        }
    };

    const syncToErpFinalAssessment = (v) => {
        setSyncingToErp(true);
        try{
            volumesService.syncToErpFinalAssessment(v).then(r => {
                addToast(t('volumes.syncSuccess'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000 });
                getVolumes();
                setSyncingToErp(false);
            }).catch(e => {
                setSyncingToErp(false);
                addToast(t('volumes.syncError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000 });
            });
        }catch(e){
            setSyncingToErp(false);
            addToast(e, { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
        }
    };

    const weighVolume = () => {
        setWeighing({
            ...weighing, 
            weight
        });
        setBtnDisabled(true);
        volumesService.weighVolume({
            ...weighing, 
            weight
        }).then(r => {
            setWeighingModalOpen(false);
            addToast(t("volumes.weighingSuccess"), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
            getVolumes();
            setBtnDisabled(false);
        }).catch(e => {
            addToast(t("volumes.weighingError"), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
            setWeighingModalOpen(false);
            setBtnDisabled(false);
        })
    };

    useEffect(() => {
        if(weighingModalOpen && config.whCode !== '79'){
            localService.getWeightFromScale().then(w => {
                setWeight(w);
                let interv = setInterval(() => {
                    localService.getWeightFromScale().then(w => {
                        setWeight(w);
                    }).catch(e => clearInterval(interv));
                }, 5000);
                setWeighingInterval(interv);
            }).catch(e => {
                if(weighingInterval){
                    clearInterval(weighingInterval);
                    setWeighingInterval(null);
                }
                addToast(t("volumes.localServiceUnreachable"), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
            })
        }
        else{
            if(weighingInterval){
                clearInterval(weighingInterval);
                setWeighingInterval(null);
            }
        }
    }, [weighingModalOpen]);

    const completeVolume = (v) => {
        setCompletingVolumeModalOpen(true);
        setVolumeToComplete(v);
    };

    const performCompleteVolume = () => {
        try{
            this.volumesService.completeVolume(volumeToComplete).then(r => {
                setCompletingVolumeModalOpen(false);
                getVolumes();
                addToast(t(`volumes.completedSuccess`), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 5000 })
            }).catch(e => {
                addToast(t("volumes.completedError"), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
            });
        }catch(e){
            addToast(t("volumes.completedError"), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        }
    } ;

    const uploadFile = (file) => {
        if(file){
            fileService.uploadFile(file).then(r => {
                addToast(t('volumes.uploadSuccess'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
                let existingImages = [];
                if(uploadingForVolume.photos){
                    existingImages = JSON.parse(uploadingForVolume.photos);
                }
                existingImages.push(JSON.parse(r)[0]);
                setUploadingForVolume({
                    ...uploadingForVolume,
                    photos: JSON.stringify(existingImages)
                });
            }).catch(e => {
                addToast(t('volumes.uploadError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
            });
        }
    };

    const updateUploadedPhotos = () => {
        volumesService.updateVolume(uploadingForVolume).then(r => {
            addToast(t('volumes.photosSavedSuccess'), {appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000});
            toggleManagePhotosModalOpen();
            getVolumes();
        }).catch(e => {
            addToast(t('volumes.photosSavedError'), {appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000});
        });
    };

    const deleteImage = (index) => {
        let images = JSON.parse(uploadingForVolume.photos);
        delete images[index];
        setUploadingForVolume({
            ...uploadingForVolume, 
            photos: JSON.stringify(images.filter(i => i))
        });
    };

    const approveVolume = (volumeId) => {
        volumesService.approveVolume(volumeId).then(r => {
            addToast("ο όγκος έγινε αποδεκτός προς διακίνηση", { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
            getVolumes();
        }).catch(e => {
            addToast("Η ενέργεια απέτυχε να ολοκληρωθεί", { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        })  
    };

    const calcFinalAssessment = (assessments) => {
        let as = authService.getConfig().products.reduce((assess, p) => {
            return assess.concat(p.assessments);
        }, [])
        if(assessments.length === 2){
            if(assessments[0].assessment === assessments[1].assessment){
                return assessments[0].assessment;
            }
            else{
                return as[Math.floor((as.indexOf(assessments[0].assessment) + as.indexOf(assessments[1].assessment))/2)];
            }
        }
    }

    const autoFinalAssessment = (v) => {
        if(window.confirm("Θέλετε να υπολογίσετε αυτόματα την τελική αξιολόγηση;")){
            volumesService.assess({
                volumeId: v.volumeId,
                assessment: calcFinalAssessment(v.assessments),
                userId: user.userId
            }).then(r => {
                addToast("Η τελική αξιολόγηση αποθηκεύθηκε", { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
                getVolumes();
            });
        }
    }

    const exportVolumes = () => {
        volumesService.exportVolumesToExcel();
    };

    const rejectVolume = (v) => {
        let images = null;
        try{
            images = JSON.parse(v.images);
        }catch(e){
        }
        if(!v.images || images.length === 0){
            addToast("Πρέπει να έχετε ανεβάσει τουλάχιστον μία φωτογραφία του όγκου για να τον απορρίψετε", 
                {appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000});
            return false;
        }
        volumesService.rejectVolume(v.volumeId).then(r => {
            getVolumes();
            addToast("Ο όγκος Απερρίφθη", {appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000});
        }).catch(e => {
            addToast("Η ενέργεια απέτυχε να ολοκληρωθεί", { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        })
    };

    return <Card style={{marginBottom: '80px'}}>
        <CardHeader className="bg-primary text-white">
            <h4>{t('volumes.addedVolumes')}</h4>
        </CardHeader>
        <CardBody>
            <Nav tabs>
                <NavItem>
                    <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => selectTab('1')}>
                        {t('volumes.createdVolumes')}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => selectTab('2')}>
                        {t('volumes.sizedAndAssessedVolumes')}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab === '5' ? 'active' : ''} onClick={() => selectTab('5')}>
                        {t('volumes.forFinalAssessment')}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab === '4' ? 'active' : ''} onClick={() => selectTab('4')}>
                        {t('Ξωφάρια')}
                    </NavLink>
                </NavItem>
                {
                    user.role === 'admin' && <NavItem>
                        <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => selectTab('3')}>
                            {t('volumes.weighedVolumes')}
                        </NavLink>
                    </NavItem>
                }
                {
                    user.role === 'admin' && <NavItem>
                        <NavLink className={activeTab === '6' ? 'active' : ''} onClick={() => selectTab('6')}>
                            Ανάλυση Αξιολογήσεων
                        </NavLink>
                    </NavItem>
                }
                {
                    user.role === 'admin' && <NavItem>
                        <NavLink className={activeTab === '7' ? 'active' : ''} onClick={() => selectTab('7')}>
                            Ανάλυση Αξιολογήσεων Ξωφάρια
                        </NavLink>
                    </NavItem>
                }
                
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId='1'>
                    <br />
                    <Alert color="info">{t('volumes.createdVolumesDescr')}</Alert>
                    {
                        (['admin', 'weigher'].includes(user.role) || ['admin', 'weigher'].includes(user.role2)) && <Button className="float-end" color="primary" onClick={toggleAddVolumeModal}>{t('volumes.createVolume')}</Button>
                    }
                    <Row>
                        <Col size={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col size={9}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    <hr />
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.quarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br/>{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.assessments')}</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {
                                                v.assessments.length > 0 && <Button color="warning" onClick={() => assessVolume(v)}>{t('volumes.viewAssessments')}</Button>
                                            }
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                v.isApproved && !v.measurementId && (['admin', 'weigher'].includes(user.role) || ['admin', 'weigher'].includes(user.role2)) && <><Button size="sm" color="primary" id={`sizing-volume-${v.volumeId}`}
                                                onClick={() => measureVolume(v.volumeId)}><FontAwesomeIcon icon={faArrowUpWideShort} /></Button>{" "}</>
                                            }
                                            {
                                                v.isApproved && ((!v.measurements || v.measurements.filter(m => m.userId === user.userId).length === 0 ) && (['assessor', 'admin'].includes(user.role) || ['assessor', 'admin'].includes(user.role2)) ) && 
                                                 <><Button size="sm" color="info" onClick={() => assessVolume(v)}><FontAwesomeIcon icon={faPenToSquare} /></Button>{" "}</>
                                            }
                                            {/* {
                                                v.isApproved && (['admin', 'weigher'].includes(user.role) || ['admin', 'weigher'].includes(user.role2))
                                                && v.assessments.length === 2 && <><Button size="sm" color="primary" id={`sizing-volume-${v.volumeId}`}
                                                onClick={() => autoFinalAssessment(v)}><FontAwesomeIcon icon={faPenToSquare} /></Button>{" "}</>
                                            } */}
                                            {
                                                (!v.isDeclined && !v.isApproved && 
                                                    (user.username === 'npertsinidis' || 
                                                    user.username === 'ekolaitis' || user.username === 'akarandreas')) && (
                                                        <>
                                                            <Button color="success" onClick={() => approveVolume(v.volumeId)} size="sm">
                                                                <FontAwesomeIcon icon={faArrowUp} />
                                                            </Button>
                                                            <Button color="danger" onClick={() => rejectVolume(v)} size="sm">
                                                                <FontAwesomeIcon icon={faArrowDown} />
                                                            </Button>
                                                        </>
                                                    )
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
                <TabPane tabId='2'>
                    <br />
                    <Alert color="info">{t('volumes.sizedAndAssessedDescr')}</Alert>
                    <Row>
                        <Col size={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col size={9}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    
                    
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.quarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.item')}</Th>
                                <Th>{t('volumes.assessment')}</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '25px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            {
                                                v.assessments.length > 0 && <Button color="warning" onClick={() => assessVolume(v)}>
                                                    {decideAssessment(v)}
                                                </Button>
                                            }
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                (['assessor', 'weigher', 'admin'].includes(user.role) || ['assessor', 'weigher', 'admin'].includes(user.role2)) && v.wh !== '79' &&
                                                    (!v.erpNumber || !v.lot || !v.createdInErp || !v.selfAssigned 
                                                        || !v.measurementSynced || !v.assessmentSynced) 
                                                    && <><Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}</>
                                            }
                                            {
                                                v.wh === '79' && v.finalAssessment !== decideAssessment(v) && 
                                                (['assessor', 'weigher', 'admin'].includes(user.role) || ['assessor', 'weigher', 'admin'].includes(user.role2)) && <>
                                                    <Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}
                                                </>
                                                
                                            }
                                            {
                                                v.wh === '79' && v.finalAssessment !== decideAssessment(v) && 
                                                (['assessor', 'weigher', 'admin'].includes(user.role) || ['assessor', 'weigher', 'admin'].includes(user.role2)) && <>
                                                    <Button size="sm" color="warning" onClick={() => syncToErpPrilepNordia(v)}><FontAwesomeIcon icon={faSync} /> Nordia</Button>{" "}
                                                </>
                                                
                                            }
                                            {
                                                (['weigher', 'admin'].includes(user.role) || ['weigher', 'admin'].includes(user.role2)) && v.erpNumber && v.lot && <><Button color="success" size="sm" onClick={() => {
                                                    setWeighing({...weighing, volumeId: v.volumeId}); 
                                                    setWeighingModalOpen(true)
                                                }}><FontAwesomeIcon icon={faWeightScale} /></Button>{" "}</>
                                            }
                                            
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
                <TabPane tabId='4'>
                    <br />
                    <Alert color="info">Μη αξιοποιήσιμοι όγκοι</Alert>
                    <Row>
                        <Col md={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col md={9}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.quarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.item')}</Th>
                                <Th>{t('volumes.assessment')}</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '25px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            {
                                                v.assessments.length > 0 && <Button color="warning" onClick={() => assessVolume(v)}>
                                                    {decideAssessment(v)}
                                                </Button>
                                            }
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                (['assessor', 'weigher', 'admin'].includes(user.role) || ['assessor', 'weigher', 'admin'].includes(user.role2)) && 
                                                    (!v.erpNumber || !v.lot || !v.createdInErp || !v.selfAssigned 
                                                        || !v.measurementSynced || !v.assessmentSynced) 
                                                    && <><Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}</>
                                            }
                                            {
                                                v.wh === '79' && v.finalAssessment !== decideAssessment(v) && 
                                                (['assessor', 'weigher', 'admin'].includes(user.role) || ['assessor', 'weigher', 'admin'].includes(user.role2)) && <>
                                                    <Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}
                                                </>
                                                
                                            }
                                            {
                                                (['weigher', 'admin'].includes(user.role) || ['weigher', 'admin'].includes(user.role2)) && v.erpNumber && v.lot && <><Button color="success" size="sm" onClick={() => {
                                                    setWeighing({...weighing, volumeId: v.volumeId}); 
                                                    setWeighingModalOpen(true)
                                                }}><FontAwesomeIcon icon={faWeightScale} /></Button>{" "}</>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
                <TabPane tabId='7'>
                    <br />
                    <Alert color="info">Ανάλυση Αξιολογήσεων - Μη Αξιοποιήσιμοι όγκοι</Alert>
                    <Row>
                        <Col md={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col md={9}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.quarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.item')}</Th>
                                <Th>1ος Αξιολογητής</Th>
                                <Th>2ος Αξιολογητής</Th>
                                <Th>3ος Αξιολογητής</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '25px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            { v.assessments[0]?.user?.name } <span style={{ color: '#00f', fontWeight: 'bold'}}>{ v.assessments[0]?.assessment }</span>
                                        </Td>
                                        <Td>
                                            { v.assessments[1]?.user?.name } <span style={{ color: '#00f', fontWeight: 'bold'}}>{ v.assessments[1]?.assessment }</span>
                                        </Td>
                                        <Td>
                                            { v.assessments[2]?.user?.name } <span style={{ color: '#00f', fontWeight: 'bold'}}>{ v.assessments[2]?.assessment }</span>
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                ['assessor', 'weigher', 'admin'].includes(user.role) && 
                                                    (!v.erpNumber || !v.lot || !v.createdInErp || !v.selfAssigned 
                                                        || !v.measurementSynced || !v.assessmentSynced) 
                                                    && <><Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}</>
                                            }
                                            {
                                                v.wh === '79' && v.finalAssessment !== decideAssessment(v) && 
                                                ['assessor', 'weigher', 'admin'].includes(user.role) && <>
                                                    <Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}
                                                </>
                                                
                                            }
                                            {
                                                ['weigher', 'admin'].includes(user.role) && v.erpNumber && v.lot && <><Button color="success" size="sm" onClick={() => {
                                                    setWeighing({...weighing, volumeId: v.volumeId}); 
                                                    setWeighingModalOpen(true)
                                                }}><FontAwesomeIcon icon={faWeightScale} /></Button>{" "}</>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
                <TabPane tabId='3'>
                <br />
                    <Alert color="info">{t('volumes.weighedVolumes')}</Alert>
                    <Row>
                        <Col size={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col size={9}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.qarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.item')}</Th>
                                <Th>{t('volumes.assessment')}</Th>
                                <Th>{t('volumes.weight')}</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.filter((v) => {
                                        if(v.measurementId && v.assessmentSynced && v.measurementSynced && v.selfAssigned && v.createdInErp && v.weight){
                                            return true;
                                        }
                                        else{
                                            return false;
                                        }
                                    }).sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            {
                                                v.assessments.length > 0 && <Button color="warning" onClick={() => assessVolume(v)}>
                                                    {decideAssessment(v)}
                                                </Button>
                                            }
                                        </Td>
                                        <Td>
                                            <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                        </Td>
                                        <Td className="text-end">
                                            <Button color="info" size="sm"><FontAwesomeIcon icon={faMoneyCheckAlt} /></Button>{" "}
                                            {
                                                user.role === 'admin' && <><Button color="success" size="sm"
                                                    onClick={() => {
                                                        completeVolume(v);
                                                    }}><FontAwesomeIcon icon={faCheck} /></Button>{" "}</>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
                <TabPane tabId='6'>
                <br />
                    <Alert color="info">Ανάλυση Αξιολογήσεων</Alert>
                    <Row>
                        <Col size={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col md={3}>
                            <Button  color="success"  className="text-white " onClick={exportVolumes}>Excel</Button>
                        </Col>
                        <Col size={6}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.qarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.item')}</Th>
                                <Th>1ος Αξιολογητής</Th>
                                <Th>2ος Αξιολογητής</Th>
                                <Th>3ος Αξιολογητής</Th>
                                <Th>{t('volumes.weight')}</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.filter((v) => {
                                        if(v.measurementId && v.assessmentSynced && v.measurementSynced && v.selfAssigned && v.createdInErp && v.weight){
                                            return true;
                                        }
                                        else{
                                            return false;
                                        }
                                    }).sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            { v.assessments[0]?.user?.name } <span style={{ color: '#00f', fontWeight: 'bold'}}>{ v.assessments[0]?.assessment }</span>
                                        </Td>
                                        <Td>
                                            { v.assessments[1]?.user?.name } <span style={{ color: '#00f', fontWeight: 'bold'}}>{ v.assessments[1]?.assessment }</span>
                                        </Td>
                                        <Td>
                                            { v.assessments[2]?.user?.name } <span style={{ color: '#00f', fontWeight: 'bold'}}>{ v.assessments[2]?.assessment }</span>
                                        </Td>
                                        <Td>
                                            <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                        </Td>
                                        <Td className="text-end">
                                            <Button color="info" size="sm"><FontAwesomeIcon icon={faMoneyCheckAlt} /></Button>{" "}
                                            {
                                                user.role === 'admin' && <><Button color="success" size="sm"
                                                    onClick={() => {
                                                        completeVolume(v);
                                                    }}><FontAwesomeIcon icon={faCheck} /></Button>{" "}</>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
                <TabPane tabId='5'>
                    <br />
                    <Alert color="info">{t('volumes.forFinalAssessmentVolumesDescr')}</Alert>
                    
                    <Row>
                        <Col size={3}>
                            <Button  color="info"  className="text-white " onClick={handleSearch}>{t('volumes.search')}</Button>
                        </Col>
                        <Col size={9}>
                            <Input type="search" onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }} />
                        </Col>
                    </Row>
                    <hr />
                    <Table className="table table-responsive table-striped">
                        <Thead>
                            <Tr>
                                <Th>{t('volumes.sn')}</Th>
                                <Th>{t('volumes.quarryLevel')}</Th>
                                <Th>{t('volumes.date')}</Th>
                                <Th>{t('volumes.dimensions')}<br/>{t('volumes.dimensionBreakdown')}</Th>
                                <Th>{t('volumes.item')}</Th>
                                <Th>{t('volumes.assessments')}</Th>
                                <Th>{t('volumes.weight')}</Th>
                                <Th className="text-end">{t('volumes.actions')}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                volumes.sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{ v.measurementId && v.measurement && (v.measurement.length + (config.whCode === '79' ? `(${v.measurement.outerLength ?? ''})` : '') 
                                            + "/" + v.measurement.width + (config.whCode === '79' ? `(${v.measurement.outerWidth ?? ''})` : '') 
                                            + "/" + v.measurement.depth + (config.whCode === '79' ? `(${v.measurement.outerDepth ?? ''})` : ''))}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '25px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            {
                                                v.assessments.length > 0 && <Button color="warning" onClick={() => assessVolume(v)}>{t('volumes.viewAssessments')}</Button>
                                            }
                                        </Td>
                                        <Td>
                                            { v.weight } kg
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                v.isApproved && ((!v.measurements || v.measurements.filter(m => m.userId === user.userId).length === 0 ) && ['assessor', 'admin'].includes(user.role) ) && 
                                                 <><Button size="sm" color="info" onClick={() => assessVolume(v)}><FontAwesomeIcon icon={faPenToSquare} /></Button>{" "}</>
                                            }
                                            {
                                                ['assessor', 'weigher', 'admin'].includes(user.role) &&
                                                v.assessments.length === 3 && 
                                                 <><Button size="sm" color="warning" onClick={() => syncToErpFinalAssessment(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}</>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                        </Tbody>
                    </Table>
                </TabPane>
            </TabContent>
        </CardBody>
        <CardFooter className="d-flex flex-wrap justify-content-between align-items-center py-2 bg-white border-top">
            <div className="d-flex flex-wrap align-items-center my-1">
                <span className="text-muted small me-3 mr-3" id="showingEntriesText">
                    {t('users.showing') || 'Showing'} {total === 0 ? 0 : startIndex + 1} - {Math.min(endIndex, total)} {t('users.of') || 'of'} {total}
                </span>
                <div className="d-flex align-items-center">
                    <Label for="perPageSelect" className="mb-0 me-2 mr-2 text-nowrap small text-muted">
                        {t('users.perPage') || 'Per page'}:
                    </Label>
                    <Input
                        type="select"
                        id="perPageSelect"
                        data-testid="perPageSelect"
                        bsSize="sm"
                        style={{ width: '80px', display: 'inline-block' }}
                        value={perPage.toString()}
                        onChange={(e) => {
                            setPerPage(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </Input>
                </div>
            </div>

            <div className="d-flex align-items-center my-1" id="paginationControls" data-testid="paginationControls">
                <Button 
                    color="secondary" 
                    outline 
                    size="sm" 
                    onClick={() => setPage(1)} 
                    disabled={currentPage <= 1} 
                    className="me-1 mr-1" 
                    title={t('users.first') || 'First'}
                    id="firstPageBtn"
                >
                    «
                </Button>
                <Button 
                    color="secondary" 
                    outline 
                    size="sm" 
                    onClick={() => setPage(p => Math.max(1, p - 1))} 
                    disabled={currentPage <= 1} 
                    className="me-1 mr-1" 
                    title={t('users.previous') || 'Previous'}
                    id="prevPageBtn"
                >
                    ‹
                </Button>
                {getPageNumbers().map(p => (
                    <Button
                        key={p}
                        color={p === currentPage ? "primary" : "secondary"}
                        outline={p !== currentPage}
                        size="sm"
                        onClick={() => setPage(p)}
                        className="me-1 mr-1"
                    >
                        {p}
                    </Button>
                ))}
                <Button 
                    color="secondary" 
                    outline 
                    size="sm" 
                    onClick={() => setPage(p => Math.min(totalPages, p + 1))} 
                    disabled={currentPage >= totalPages} 
                    className="me-1 mr-1" 
                    title={t('users.next') || 'Next'}
                    id="nextPageBtn"
                >
                    ›
                </Button>
                <Button 
                    color="secondary" 
                    outline 
                    size="sm" 
                    onClick={() => setPage(totalPages)} 
                    disabled={currentPage >= totalPages} 
                    title={t('users.last') || 'Last'}
                    id="lastPageBtn"
                >
                    »
                </Button>
            </div>
        </CardFooter>
        <Modal isOpen={addVolumeModal} toggle={toggleAddVolumeModal} centered>
            <ModalHeader>
                <h4>{t('volumes.createVolume')}</h4>
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={submitAddVolume}>
                    <FormGroup>
                        <Label>{t('volumes.quarryLevel')}</Label>
                        <Input type="select" onChange={(e) => setNewVolume({...newVolume, self: e.target.value})}>
                            <option value="">{t('volumes.selectQuarryLevel')}</option>
                            {
                                getShelves().map(s => <option key={s} value={s}>{s}</option>)
                            }
                        </Input>    
                    </FormGroup>
                    
                    <br />
                    <Button color="primary" disabled={btnDisabled} block>{t('volumes.create')}</Button>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button className="ms-auth" color="danger" onClick={toggleAddVolumeModal}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={measureVolumeOpen} toggle={toggleMeasureVolumeOpen} centered>
            <ModalHeader>
                <h4>{t('volumes.sizeBlock')}</h4>
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={submitMeasureVolume}>
                    <FormGroup>
                        <Label>{t('volumes.length')}</Label>
                        <Input type="text" onChange={(e) => setMeasurement({
                        ...measurement,
                        length: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup>
                        <Label>{t('volumes.width')}</Label>
                        <Input type="text" onChange={(e) => setMeasurement({
                        ...measurement,
                        width: e.target.value
                        })} />
                    </FormGroup>
                    <FormGroup>
                        <Label>{t('volumes.height')}</Label>
                        <Input type="text" onChange={(e) => setMeasurement({
                        ...measurement,
                        depth: e.target.value
                        })} />
                    </FormGroup>
                    {
                        config.whCode === '79' && <>
                            <FormGroup>
                                <Label>{t('volumes.outerLength')}</Label>
                                <Input type="text" onChange={(e) => setMeasurement({
                                    ...measurement,
                                    outerLength: e.target.value
                                })} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{t('volumes.outerWidth')}</Label>
                                <Input type="text" onChange={(e) => setMeasurement({
                                    ...measurement,
                                    outerWidth: e.target.value
                                })} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{t('volumes.outerHeight')}</Label>
                                <Input type="text" onChange={(e) => setMeasurement({
                                    ...measurement,
                                    outerDepth: e.target.value
                                })} />
                            </FormGroup>
                        </>
                    }
                    <Button color="primary" disabled={btnDisabled} block>{t('volumes.save')}</Button>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button  color="danger" className="ms-auto" onClick={() => { setMeasurement({}); toggleMeasureVolumeOpen() }}>
                    {t('volumes.cancel')}
                </Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={assessmentsModalOpen} toggle={toggleAssessmentsModalOpen} centered>
            <ModalHeader>
                <h4>{t('volumes.assessments')}</h4>
            </ModalHeader>
            <ModalBody>
                {
                    activeVolume.volumeId && <>
                        <h3>{t('volumes.sn')}: {activeVolume.date.split('T')[0].split('-').reverse()[0]} - {activeVolume.dayNumber}</h3>
                        <h4>{t('volumes.qarryLevel')}: {activeVolume.self}</h4>
                    </>
                }
                {
                    ['assessor', 'admin'].includes(user.role) && <>
                        <Table className="table table-responsive table-striped">
                            <Thead>
                            <Tr>
                                {
                                    user.role === 'admin' && <Th>{t('volumes.user')}</Th>
                                }
                                <Th>{t('volumes.order')}</Th>
                                <Th>{t('volumes.assessment')}</Th>
                            </Tr>
                            </Thead>
                            <Tbody>
                            {
                                assessments.filter((a) => {
                                    return user.role === 'admin' || a.userId === user.userId; 
                                }).
                                map((a, i) => {
                                return <Tr key={i}>
                                    {user.role === 'admin' && 
                                        <Td>{a.user.name}</Td>
                                    }
                                    <Td>{i+1}</Td>
                                    <Td>{a.assessment}</Td>
                                </Tr>
                                })
                            }
                            </Tbody>
                        </Table>
                    </>
                }
                {
                    (['admin', 'manager', 'assessor'].includes(user.role) || ['admin', 'manager', 'assessor'].includes(user.role2)) && assessments.filter(a => a.userId === user.userId).length === 0 && <Button
                        color="primary" size="sm" onClick={() => setAddingAssessment(true)}> 
                        {t('volumes.assessment')}
                    </Button>
                }
                {
                    addingAssessment && <Form onSubmit={createAssessment}>
                        <FormGroup>
                            <Label>{t('volumes.assessment')}</Label>
                            <Input type="select" onChange={(e) => {
                                setAssessment({
                                    ...assessment,
                                    assessment: e.target.value
                                });
                            }}>
                                <option value="">{t('volumes.selectAssessment')}</option>
                                {
                                    authService.getConfig().products.reduce((assess, p) => {
                                        return config.whCode === '79' && assessments.length < 2 ? assess.concat(p.firstAssessments) : assess.concat(p.assessments);
                                    }, []).filter(a => a!=='Ξ').map((a) => {
                                        return <option value={a}>{a}</option>
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <Button color="primary" disabled={btnDisabled} size="sm">{t('volumes.save')}</Button>
                    </Form>
                }
            </ModalBody>
            <ModalFooter>
                <Button className="ms-auto" color="danger" onClick={toggleAssessmentsModalOpen}>{t('volumes.cancel')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={syncingToErp} centered>
            <ModalBody>
                <Alert color="info">
                    {t('volumes.syncingBlock')}
                </Alert>
            </ModalBody>
        </Modal>
        <Modal isOpen={weighingModalOpen} toggle={() => setWeighingModalOpen(!weighingModalOpen)} centered>
            <ModalHeader>
                <h4>{t('volumes.weighingBlock')}</h4>
            </ModalHeader>
            <ModalBody>
                {
                    config.whCode === '79' && <FormGroup>
                        <Label>{t('volumes.weight')}</Label>
                        <Input type="text" onChange={(e) => setWeight(e.target.value)} />
                    </FormGroup>
                }
                <Alert className="text-center" size="xl" color="primary"><h2>{weight}kg</h2></Alert>
                <Button color="primary" disabled={btnDisabled} block onClick={() => weighVolume()}>{t('volumes.weigh')}</Button>
            </ModalBody>
            <ModalFooter>
                <Button className="ms-auto" color="warning" size="sm" onClick={() => setWeighingModalOpen(false)}>{t('volumes.cancel')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={completingVolumeModalOpen} toggle={() => setCompletingVolumeModalOpen(!completingVolumeModalOpen)} centered>
            <ModalHeader>
                <h4>{t('volumes.completeBlockManagement')}</h4>
            </ModalHeader>
            <ModalBody>
                <Alert className="text-center" size="xl" color="primary">{t('volumes.selectCompletionMessage')}</Alert>
            </ModalBody>
            <ModalFooter>
                <Button color="success" size="sm" onClick={performCompleteVolume}>{t('volumes.complete')}</Button>
                <Button className="ms-auto" color="warning" size="sm" onClick={() => setCompletingVolumeModalOpen(false)}>{t('volumes.cancel')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={managingPhotosModalOpen} toggle={() => toggleManagePhotosModalOpen} centered size="xl">
            <ModalHeader>
                <h4>{t('volumes.blockPhotos')}</h4>
            </ModalHeader>
            <ModalBody>
                <Input type='file' onChange={(e) => {uploadFile(e.target.files[0])}} placeholder={t('volumes.uploadFilesHere')}/>
                <hr />

                <Row>
                    {
                        uploadingForVolume.photos && JSON.parse(uploadingForVolume.photos).length && JSON.parse(uploadingForVolume.photos).map((p, i) => {
                            return <Col md="3" className='text-center'>
                                {
                                    p && p.type.includes('image') && <><img src={fileService.getUrl(p.name)} alt={fileService.getUrl(p.name)} style={{ width: '95%' }} 
                                        onClick={() => {
                                            setActiveImage(fileService.getUrl(p.name));
                                            toggleSeeingImage();
                                        }}/>
                                        <br />
                                        {
                                            user.role === 'admin' && <Button color='danger' size="sm" onClick={() => deleteImage(i)}><FontAwesomeIcon icon={faTimes} /> {t('volumes.delete')}</Button>
                                        }
                                    </>
                                }
                            </Col>
                        })
                    }
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" size="sm" onClick={updateUploadedPhotos}>{t('volumes.save')}</Button>
                <Button className="ms-auto" color="warning" size="sm" onClick={toggleManagePhotosModalOpen}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={seeingImage} toggle={toggleSeeingImage} size="xl" centered>
            <ModalBody>
                <img src={activeImage} style={{width: '100%'}} alt="img" />
            </ModalBody>
            <ModalFooter>
                <Button className="ms-auto" color="warning" size="sm" onClick={toggleSeeingImage}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
    </Card>
}

export default withTranslation(Volumes);